import React from 'react';
import InfoIcon from 'shared/components/info-icon';
import {FieldMetaProps} from 'formik';
import {CurrentInstitution} from 'src/types/education';

interface Props {
  parentId: FieldMetaProps<Pick<CurrentInstitution, 'parentId'>>;
  NeedHelp: React.ReactNode;
  NeedHelpListItems: React.ReactNode;
}

export const ParentIdError = (props: Pick<Props, 'parentId'>) => (
  <p style={{margin: '12px 0'}} className="shared-error-text" role="alert">
    {(props.parentId.touched && props.parentId.error) || <br />}
  </p>
);

export function TypeaheadViewFooter(props: Props) {
  return (
    <>
      <ParentIdError parentId={props.parentId} />
      <h2 className="need-help">
        <InfoIcon className="info-icon" size={16} />
        {props.NeedHelp}
      </h2>
      <ul className="need-help onboarding-institution-step-need-help-list">
        {props.NeedHelpListItems}
      </ul>
    </>
  );
}
